import { Component, Prop, Watch } from 'vue-property-decorator';
import { VTextField } from 'vuetify/lib';
import { Debounce } from '@/decorators';

@Component
export default class SearchInput extends VTextField {
  @Prop({ default: '' }) placeholder: string;
  @Prop({ default: false }) disabled: boolean;

  private search = '';

  @Watch('search')
  @Debounce(500)
  searchListener(): void {
    this.$emit('onChange', this.search);
  }
}
